import React from 'react';
import { WatchtowerMark } from './WatchtowerMark';
interface WordmarkProps {
  /** 'light' sits on cream/white, 'dark' on the shell. */
  tone?: 'light' | 'dark';
  size?: 'sm' | 'md' | 'lg';
  /** Hides the WORKS line where vertical space is tight. */
  showSubline?: boolean;
  className?: string;
}
const marks = {
  sm: 'h-7 w-7',
  md: 'h-9 w-9',
  lg: 'h-12 w-12'
} as const;
const titles = {
  sm: 'text-[15px]',
  md: 'text-[19px]',
  lg: 'text-[26px]'
} as const;
const sublines = {
  sm: 'text-[8px] tracking-[0.34em]',
  md: 'text-[9px] tracking-[0.36em]',
  lg: 'text-[11px] tracking-[0.38em]'
} as const;

/** The full lockup: mark, Watchtower, and the WORKS subline beneath it. */
export function Wordmark({
  tone = 'light',
  size = 'sm',
  showSubline = true,
  className = ''
}: WordmarkProps) {
  return <span className={`flex items-center gap-2.5 ${className}`} data-id="element-513" data-mp="u9d6s8qu7bhu">
      <WatchtowerMark className={`${marks[size]} shrink-0 ${tone === 'dark' ? 'text-white' : 'text-brand'}`} data-id="element-514" data-mp="z8q3dl7ifwxm" />
      <span className="min-w-0" data-id="element-515" data-mp="19k9tn0tzp7nm">
        <span className={`block font-semibold leading-none tracking-tight ${titles[size]} ${tone === 'dark' ? 'text-white' : 'text-brand'}`} data-id="element-516" data-mp="14lp1zpsszwas">
          Watchtower
        </span>
        {showSubline && <span className={`mt-1 block font-medium uppercase leading-none ${sublines[size]} ${tone === 'dark' ? 'text-white/50' : 'text-ink-soft'}`} data-id="element-517" data-mp="umpqlzgnlmk3">
            Works
          </span>}
      </span>
    </span>;
}